import { saveAs } from 'file-saver';

declare const pendo: any;

/**
 * Async Timeout/Delay Function
 * @param time
 */
export const waitFor = (time: number) => {
  return new Promise((resolve, reject) => {
    if (isNaN(time)) {
      return reject(new Error('Parameter must be a number'));
    }
    setTimeout(resolve, time);
  });
};

export const getUTCTime = (date: Date) => {
  return Date.UTC(
    date.getUTCFullYear(),
    date.getUTCMonth(),
    date.getUTCDate(),
    date.getUTCHours(),
    date.getUTCMinutes(),
    date.getUTCSeconds()
  );
};

export const isLegacyLoginRescueActive = () => {
  const currentTime = getUTCTime(new Date());

  if (currentTime > new Date('2022-07-11T00:00:00.000Z').getTime()) return true;

  const lsNewLoginFlag: string | null = localStorage.getItem('C1C_USE_WSRESCUE_LOGIN');

  if (lsNewLoginFlag === null) {
    return false;
  } else {
    if (lsNewLoginFlag === 'false' || lsNewLoginFlag === 'true') {
      return JSON.parse(lsNewLoginFlag);
    } else {
      try {
        return currentTime > new Date(lsNewLoginFlag).getTime();
      } catch (e) {
        console.error(
          'Error retrieving date from C1C_USE_WSRESCUE_LOGIN localStorage key for login rescue form feature flag. Make sure the value of C1C_USE_WSRESCUE_LOGIN is readable by new Date()'
        );
        return false;
      }
    }
  }
};

export const copyToClipboard = async (content: string): Promise<boolean> => {
  if (!content) {
    console.warn('No value provided to the clipboard');
    return false;
  }
  try {
    await navigator.clipboard.writeText(content);
    return true;
  } catch (error) {
    console.error('Copy to clipboard failed: ', error);
    return false;
  }
};

export const gotoSignIn = (eventDistributor: Record<any, any>): void => {
  eventDistributor.dispatch({
    type: 'NAVIGATE_APP',
    appName: '/',
  });
};

/**
 * Downloads the given content as a text file
 *
 * @param {string} content
 * @param {string} filename
 * @returns {void}
 */
export const downloadTextAsFile = (content: string, filename?: string): void => {
  if (!content) {
    console.error('No content to download');
    return;
  }
  saveAs(
    new Blob([content], { type: 'text/plain;charset=utf-8' }),
    `${filename || `${+Date.now()}`}.txt`
  );
};

/**
 * Handler for sending custom events to Pendo
 * @param eventName
 * @param params
 */
export const sendEventTrack = (eventName, params) => {
  try {
    if (typeof window['pendo'] !== 'undefined' && eventName) {
      /* eslint-disable */
      pendo?.track(eventName, params);
    }
  } catch (e) {
    console.error('Pendo error: ', e);
  }
};

// TODO: Remove the FeatureFlag check with C1C-11968
const checkGovCloudRegion = (): boolean => {
  const isGovCloudDeploymentTarget = ['govcloud-prod', 'govcloud-staging'].includes(
    DEPLOYMENT_TARGET
  );
  const hasGovCloudFeatureFlag = JSON.parse(
    localStorage.getItem('C1C_GOV_CLOUD_ENABLED') || 'false'
  );
  return isGovCloudDeploymentTarget || hasGovCloudFeatureFlag;
};
export const isGovCloudRegion = checkGovCloudRegion();

export const isMaintenanceModeEnabled = JSON.parse(
  localStorage.getItem('C1C_Maintenance_Mode') || 'false'
) as boolean;
